export default __webpack_public_path__ + "static/Supply-Chain-Transparency-f80e87b975389e5cab5b4f27ca055922.pdf";